<template>
   <div class="pages-routing">
      <a-layout>
         <a-layout-header>
            <TopBar></TopBar>
            <HeadBar></HeadBar>
         </a-layout-header>
         <a-layout-content><router-view></router-view></a-layout-content>
         <a-layout-footer><kw-common-pc-footbar></kw-common-pc-footbar></a-layout-footer>
      </a-layout>
   </div>
</template>
<script>
import {Layout} from 'ant-design-vue'

import TopBar from '@components/topBar'
import HeadBar from '@components/headBar'
// import FootBar from '@components/footBar'
export default {
   components:{TopBar,HeadBar,'a-layout':Layout,'a-layout-content':Layout.Content,'a-layout-header':Layout.Header,'a-layout-footer':Layout.Footer}
}
</script>
<style lang="scss" scoped>
 .pages-routing {
    background-color: #f0f2f5;
      .ant-layout-header {
         background-color: #fff;
         padding: 0;
         height: auto;
         line-height: normal;
      }
 
    .ant-layout-footer {
       padding: 0;
    }
 
 }
</style>


